const data = {
  days: {
    en: {
      short: {
        0: 'Sun',
        1: 'Mon',
        2: 'Tue',
        3: 'Wed',
        4: 'Thu',
        5: 'Fri',
        6: 'Sat',
      },
      full: {
        0: 'Sunday',
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday',
      },
    },
    ru: {
      short: {
        0: 'Вс',
        1: 'Пн',
        2: 'Вт',
        3: 'Ср',
        4: 'Чт',
        5: 'Пт',
        6: 'Сб',
      },
      full: {
        0: 'Воскресенье',
        1: 'Понедельник',
        2: 'Вторник',
        3: 'Среда',
        4: 'Четверг',
        5: 'Пятница',
        6: 'Суббота',
      },
    },
    be: {
      short: {
        0: 'Нд',
        1: 'Пн',
        2: 'Аў',
        3: 'Ср',
        4: 'Чц',
        5: 'Пт',
        6: 'Сб',
      },
      full: {
        0: 'Нядзеля',
        1: 'Панядзелак',
        2: 'Аўторак',
        3: 'Серада',
        4: 'Чацвер',
        5: 'Пятніца',
        6: 'Субота',
      },
    },
  },
  months: {
    en: {
      0: 'January',
      1: 'February',
      2: 'March',
      3: 'April',
      4: 'May',
      5: 'June',
      6: 'July',
      7: 'August',
      8: 'September',
      9: 'October',
      10: 'November',
      11: 'December',
    },
    ru: {
      0: 'Январь',
      1: 'Февраль',
      2: 'Март',
      3: 'Апрель',
      4: 'Май',
      5: 'Июнь',
      6: 'Июль',
      7: 'Август',
      8: 'Сентябрь',
      9: 'Октябрь',
      10: 'Ноябрь',
      11: 'Декабрь',
    },
    be: {
      0: 'Студзеня',
      1: 'Лютага',
      2: 'Сакавіка',
      3: 'Красавіка',
      4: 'Май',
      5: 'Чэрвеня',
      6: 'Ліпеня',
      7: 'Жніўня',
      8: 'Верасня',
      9: 'Кастрычніка',
      10: 'Лістапад',
      11: 'Сьнежня',
    },
  },
};

export default data;
